import { render, staticRenderFns } from "./ContratacaoDetalhesCardLocais.vue?vue&type=template&id=ddb0e9a6&"
import script from "./ContratacaoDetalhesCardLocais.vue?vue&type=script&lang=js&"
export * from "./ContratacaoDetalhesCardLocais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
